/** @format */

import {Chart} from 'components/charts/multiline-chart/model/charts';
import {TooltipData} from 'components/charts/multiline-chart/model/tooltip';

interface Options<ChartId> {
  tooltipData: TooltipData<ChartId>;
  charts: Chart<ChartId>[];
  chartIndex: number;
  openedScattersCount: number;
}

/**
 * Тултип является общим для всех графиков, поэтому применяется следующее правило отображения:
 * Вычисляется первый в массиве график, для которого есть тултип-данные.
 * Если индекс массива этого графика совпадает с текущим индексом, то отображаем тултип.
 * Количество открытых скаттеров увеличивает индекс, с которым идет сравнение.
 * @param tooltipData
 * @param charts
 * @param chartIndex
 * @param openedScattersCount
 */

const isShowTooltip = <ChartId>({
  tooltipData,
  charts,
  chartIndex,
  openedScattersCount,
}: Options<ChartId>): boolean => {
  const allTooltipChartIds = tooltipData.rows?.map(d => d.chartId) || [];
  const firstValidIndex = charts.findIndex(chart => allTooltipChartIds.includes(chart.chartId));
  return chartIndex + openedScattersCount === firstValidIndex;
};

export default isShowTooltip;
